module.exports = __webpack_public_path__ + "static/media/hexagon-sustainable-supply-chains.e1361efd.svg";